import { render, staticRenderFns } from "./suppliers-sites-input.vue?vue&type=template&id=2186649e&"
import script from "./suppliers-sites-input.vue?vue&type=script&lang=js&"
export * from "./suppliers-sites-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports